
export default function useHooks(
    user: Model.Response<Admin.Resources.User>, 
    api: Admin.Models.User.Api, 
    methods: Admin.Models.User.Methods,
    actions: Admin.Models.User.Actions
): Admin.Models.User.Hooks {
    return { }
}